import React from 'react';
const PaginationContext = React.createContext(undefined);
export default PaginationContext;
//# sourceMappingURL=PaginationContext.js.map